<template>
    <modal class="collectDepositModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">收取定金
            <i class="iconfont icon-guanbi" @click="hide()"></i>
        </div>
        <div class="modal-body">
            <!-- 表单区域 -->
            <div class="info-box">
                <div class="tr-from tr-flex">
                    <div class="flex1">
                        <div class="lable-name">收据编号</div>
                        <div class="from-box">
                            <div class="from-input"><input type="text" v-model="receiptCode"/></div>
                        </div>
                    </div>
                    <div class="flex1">
                        <div class="lable-name">付款方式</div>
                        <div class="from-box">
                            <el-select v-model="Payment_ID" placeholder="请选择" value-key="item">
                                <el-option  v-for="item in payTypeList" :key="item.PAY_ID" :label="item.PAY_NAME" :value="item.PAY_ID"> </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="tr-from tr-flex">
                    <div class="flex1">
                        <div class="lable-name">付款金额（元）</div>
                        <div class="from-box">
                            <div class="from-input"><input-pattern pattern="money" type="text" v-model="paymentAmount"/></div>
                        </div>
                    </div>
                    <div class="flex1">
                        <div class="lable-name">备注</div>
                        <div class="from-box">
                            <div class="from-input"><input type="text" v-model="remark" placeholder="可选"/></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 上传凭证截图 -->
            <div class="upload-box">
                <label class="upload-area" for="deposit-upload">
                    <input type="file" id="deposit-upload" accept="image/png,image/jpeg,image/jpg" @change="handleFileChange" style="display:none"/>
                    <i class="iconfont icon-paizhao1 upload-icon"></i>
                    <div class="upload-text">点击上传或拖拽截图到此处</div>
                    <div class="upload-tip">支持 PNG / JPG / JPEG，最多 1 张</div>
                </label>
                <div class="preview-list" v-show="previewList.length>0">
                    <div class="preview-item" v-for="(file, index) in previewList" :key="index">
                        <img :src="file.url"/>
                        <div class="delete-btn" @click="removeFile(index)"><i class="iconfont icon-guanbi"></i></div>
                    </div>
                </div>
            </div>

            <!-- 已付列表 -->
            <div class="list-box">
                <div class="title">已付列表</div>
                <div class="table-box" ref="kitNameTable">
                    <el-table class="el-table--scrollable-y" style="width: 100%;" border v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}"
                        :data="paymentTableData" highlight-current-row>
                        <el-table-column prop="ReceiptNO" label="收据编号" min-width="110"></el-table-column>
                        <el-table-column prop="Payment_Name" label="付款方式" min-width="80"></el-table-column>
                        <el-table-column prop="Payment_Money" label="金额（元）" min-width="75"></el-table-column>
                        <el-table-column prop="Pre_Czy" label="收款人" min-width="65"></el-table-column>
                        <el-table-column prop="Pre_Time" label="收款时间" width="85" :formatter="formatter"></el-table-column>
                        <el-table-column prop="Pre_Remark" label="备注" min-width="50"></el-table-column>
                        <el-table-column label="操作" width="60" align="center">
                            <template #default="scope">
                                <span class="revoke-bnt" @click="revoke(scope)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="confirm()">确认</button>
        </div>
    </modal>
</template>

<script>
// 收取定金
export default {
    name:'collectDepositModel',
    props:{
        isShow:Boolean,
        //定金数据
        data:{
            type:Array,
            default:null
        }
    },
    data(){
        return{
            /**付款方式数据 */
            payTypeList:[],
            /**选中的 付款方式 */
            Payment_ID:'',
            //收据编号
            receiptCode: '',
            //付款金额
            paymentAmount: '',
            //备注
            remark: '',
            //预览图片列表 {url, src}
            previewList: [],
            //已付款数据
            paymentTableData:[]
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.init();
        });
    },
    watch:{
        isShow(newValue){
            if(newValue){
                this.init();
            }
        }
    },
    methods:{
        /**初始化数据 */
        init(){
            if(!(this.payTypeList?.length>0)){
                const loading = this.$loading({
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                const userInfo=this.$auth.getUserInfo(); //获取用户id
                const param={
                    User_ID: userInfo.User_ID,
                    Department_ID:userInfo.Department_ID
                }
                this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetPaymentKinds",param).then((d)=>{
                    loading?.close();
                    if (d.ResponseHeader.ResultCode != 0) {
                        this.$alert(d.ResponseHeader.ResultDesc, "错误提示");
                    }else{
                        let all=[]
                        d.ResponseBody?.forEach(item => {
                            item.PayTypes.forEach((type)=>{
                                if(([1,2,801010301,801010401]).includes(type.INTERFACE_TYPE)){
                                    all.push(type)
                                }
                            })
                        });
                        this.payTypeList=all;
                    }
                }).catch((e)=>{
                    loading?.close();
                    this.$alert(e.message,'错误提示');
                    console.log('加载付款方式数据失败：'+e);
                })
            }
            // 置空字段，方便再次添加
            this.receiptCode = '';
            this.paymentAmount = '';
            this.remark = '';
            this.Payment_ID = '';
            this.previewList = [];
            this.paymentTableData=this.data||[];
        },
        hide(){
            this.$emit("close");
        },
        /*时间格式 */
        formatter(row, column, cellValue) {
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd hh:mm:ss');
        },
        confirm(){
            // 校验收据编号
            if(!this.receiptCode || !this.receiptCode.trim()){
                this.$message.warning('请输入收据编号');
                return;
            }
            // 校验付款方式
            if(!this.Payment_ID){
                this.$message.warning('请选择付款方式');
                return;
            }
            // 校验金额大于0
            const amount = Number(this.paymentAmount);
            if(!amount || amount <= 0){
                this.$message.warning('请输入有效的付款金额（大于0）');
                return;
            }

            const userInfo=this.$auth.getUserInfo(); //获取用户id
            
            this.paymentTableData.push({
                Payment_Money:amount,
				ReceiptNO:this.receiptCode.trim(),
				Pre_Remark:this.remark.trim(),
				Payment_ID:this.Payment_ID,
				Payment_Name:this.payTypeList.find(it=>it.PAY_ID==this.Payment_ID).PAY_NAME,
				ReceiptNOURL:(this.previewList||[])[0]?.url,
                Pre_Time:new Date().Format("yyyy-MM-dd hh:mm:ss"),
                Pre_Czy:userInfo.Login_Name,
                Department_ID:userInfo.Department_ID,
                Department_Name:userInfo.Department_Name,
                Pre_PosName:""
            })
            // 置空字段，方便再次添加
            this.receiptCode = '';
            this.paymentAmount = '';
            this.remark = '';
            this.Payment_ID = '';
            this.previewList = [];
            this.$emit("confirm",this.paymentTableData);
        },
        /**处理文件选择 */
        handleFileChange(e){
            const files = Array.from(e.target.files || []);
            if(files.length === 0) return;
            if(this.previewList.length >= 1){
                this.$message.warning('最多只能上传1张图片');
                return;
            }
            const file = files[0];
            this.uploadFile(file).then(res => {
                if(res && res.src){
                    this.previewList = [{ url: res.src, src: res.src }];
                }
            }).catch(err => {
                console.error('上传图片失败：', err);
            });
            e.target.value = '';
        },
        /**上传单个文件 */
        uploadFile(file){
            return this.$httpAES.tradeUploadFile(file).then(d => {
                // d 为 tradeUploadFile 返回的原始数据 {Status:0, BizData:{src:"图片地址"}, Message:""}
                if(d && d.Status === 0 && d.BizData && d.BizData.src){
                    return { src: d.BizData.src };
                }else{
                    this.$message.error(d?.Message || '图片上传失败');
                    return null;
                }
            }).catch(err => {
                this.$message.error('图片上传失败：' + (err?.errMsg || err?.message || '未知错误'));
                return null;
            });
        },
        /**移除文件 */
        removeFile(index){
            this.previewList.splice(index, 1);
        },
        /**撤销 */
        revoke({row,$index}){
            this.$confirm("你确定要撤销这笔定金吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText:"取消",
                type: 'warning',
				callback: (name) => {
					if(name=='confirm'){
						this.paymentTableData.splice($index,1)
					}
				},
			});
        }
    }
}
</script>

<style lang="scss">
@import './collectDepositModel.scss'
</style>
